










































































































































import { Vue, Component, Watch } from "vue-property-decorator";

import KSlider from "@/components/KSlider.vue";
import KSelectOption from "@/components/KSelectOption.vue";
import KTextField from "@/components/KTextField.vue";
import { generatePhoneticWords, generateWords } from "@/common/helper";

interface TestOptions {
  difficulty: number;
  length: number;
  capitalLetterProbability: number;
  punctuationProbability: number;
  language: string;
}

@Component({
  components: { KSlider, KSelectOption, KTextField }
})
export default class Home extends Vue {
  testOptions: TestOptions = {
    difficulty: 1,
    length: 20,
    capitalLetterProbability: 0,
    punctuationProbability: 0,
    language: "phonetic"
  };

  languages = [
    "phonetic",
    "english",
    { label: "──────────" },
    "afrikaans",
    "albanian",
    "arabic",
    "armenian",
    "azerbaijani",
    "basque",
    "belarusian",
    "bengali",
    "bosnian",
    "bulgarian",
    "catalan",
    "cebuano",
    "chichewa",
    "chinese",
    "corsican",
    "croatian",
    "czech",
    "danish",
    "dutch",
    "esperanto",
    "estonian",
    "filipino",
    "finnish",
    "french",
    "frisian",
    "galician",
    "georgian",
    "german",
    "greek",
    "gujarati",
    "haitian",
    "hausa",
    "hawaiian",
    "hebrew",
    "hindi",
    "hmong",
    "hungarian",
    "icelandic",
    "igbo",
    "indonesian",
    "irish",
    "italian",
    "japanese",
    "javanese",
    "kannada",
    "kazakh",
    "khmer",
    "korean",
    "kurdish",
    "kyrgyz",
    "lao",
    "latin",
    "latvian",
    "lithuanian",
    "luxembourgish",
    "macedonian",
    "malagasy",
    "malayalam",
    "malaysian",
    "maltese",
    "maori",
    "marathi",
    "mongolian",
    "myanmar",
    "nepali",
    "norwegian",
    "pashto",
    "persian",
    "polish",
    "portuguese",
    "punjabi",
    "romanian",
    "russian",
    "serbian",
    "sesotho",
    "shona",
    "sindhi",
    "sinhala",
    "slovak",
    "slovenian",
    "somali",
    "spanish",
    "sundanese",
    "swahili",
    "swedish",
    "tajik",
    "tamil",
    "telugu",
    "thai",
    "turkish",
    "ukrainian",
    "urdu",
    "uzbek",
    "vietnamese",
    "welsh",
    "xhosa",
    "yiddish"
  ];

  name = localStorage.name || "";
  wpm = localStorage.wpm || 0;
  errors = localStorage.errors || 0;

  startTime = 0;
  words: string[] = [];
  typedWord = "";
  typedWords: string[] = [];

  showOption = false;
  isFullWidth = false;

  get complexityOptions() {
    return [
      {
        label: this.testOptions.language === "phonetic" ? "Low" : "200 Most Common Words",
        value: 1
      },
      {
        label: this.testOptions.language === "phonetic" ? "Medium" : "200-800 Most Common Words",
        value: 2
      },
      {
        label: this.testOptions.language === "phonetic" ? "High" : "800-1000 Most Common Words",
        value: 3
      }
    ];
  }

  @Watch("testOptions", { deep: true })
  onTestOptionsChange() {
    this.startNewRound();
  }

  created() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let storedOptions: Partial<TestOptions> = {};
    try {
      storedOptions = JSON.parse(localStorage.testOptions);
    } catch (err) {
      /* Not found */
    }
    this.testOptions = {
      difficulty: +(storedOptions?.difficulty ?? 1),
      length: +(storedOptions?.length ?? 20),
      capitalLetterProbability: +(storedOptions?.capitalLetterProbability ?? 0),
      punctuationProbability: +(storedOptions?.punctuationProbability ?? 0),
      language: storedOptions?.language ?? "phonetic"
    };
  }

  /**
   * Start new round
   */
  startNewRound() {
    this.typedWord = "";
    this.words = [];
    this.startTime = 0;
    this.typedWords = [];
    this.words =
      this.testOptions.language === "phonetic"
        ? generatePhoneticWords(this.testOptions)
        : generateWords(this.testOptions);

    localStorage.testOptions = JSON.stringify(this.testOptions);
  }

  /**
   * Reset current round
   */
  resetRound() {
    this.typedWord = "";
    this.startTime = 0;
    this.typedWords = [];
  }

  /**
   * Called each time a key is pressed on the text field
   */
  eachKey() {
    // Start timer
    if (this.startTime == 0) this.startTime = performance.now();

    // If typed word is empty, restart the timer
    if (this.typedWords.length === 0 && !this.typedWord.trim()) {
      this.startTime = 0;
    }

    // Add last word if it's correctly typed
    // Auto finish round if last word is correctly typed
    if (
      this.typedWords.length == this.testOptions.length - 1 &&
      this.typedWord.trim() == this.words[this.testOptions.length - 1]
    ) {
      this.addTypedWords();
    }
  }

  /**
   * Store typed words when user pressed space
   */
  addTypedWords() {
    if (!this.typedWord.trim()) return;
    this.typedWords.push(this.typedWord.trim());
    this.typedWord = "";
    if (this.typedWords.length == this.words.length) {
      this.finishRound();
    }
  }

  /**
   *
   */
  finishRound() {
    const duration = performance.now() - this.startTime;
    const errorCount = this.words.filter((word, i) => word !== this.typedWords[i]).length;

    this.errors = errorCount;
    this.wpm = parseFloat(
      ((60 / (duration / 1000)) * (this.testOptions.length - errorCount)).toFixed(2)
    );

    this.startNewRound();
  }
}
